<template>
  <div id="following" v-if="getAllWatchlist && getAllWatchlist.length">
    <h2 class="header">
      <i class="fa fa-star"></i>
      สินทรัพย์ที่ติดตาม
    </h2>
    <div v-if="getCountWatchlistAsset.count === 1">
      <div class="one-item-list" v-if="topStockWatchlist && topStockWatchlist.length">
        <div class="one-item-list__title">หุ้น</div>
        <list-item
          v-for="(stock,index) in topStockWatchlist"
          :data-action="'open_stock'"
          :data-listname="'home_following_stock'"
          :data-stockname="stock.name"
          :key="stock.id"
          :index="index + 1"
          :name="stock.name"
          :date="stock.data_date"
          :period="'1 Day'"
          :price="stock.price"
          :change="stock.percent"
          :action="navigateToStock"
          :query="{name: stock.name}"
        ></list-item>
      </div>
      <div class="one-item-list" v-if="topFundWatchlist && topFundWatchlist.length">
        <div class="one-item-list__title">กองทุน</div>
        <list-item
          v-for="(fund,index) in topFundWatchlist"
          :data-action="'open_fund'"
          :data-listname="'home_following_fund'"
          :data-fundname="fund.name"
          :key="fund.id"
          :index="index + 1"
          :name="fund.name"
          :date="fund.data_date"
          :period="'1 Day'"
          :price="fund.price"
          :change="fund.percent"
          :action="navigateToFund"
          :query="{id:fund.id}"
        ></list-item>
      </div>
      <div class="one-item-list" v-if="getGoldWatchlist && getGoldWatchlist.length">
        <div class="one-item-list__title">ทอง</div>
        <BoxAsset
          :data-action="'open_gold'"
          :data-listname="'following_gold'"
          :data-assettype="'gold'"
          :data-assetname="item.name"
          class="one-item-list__content"
          v-for="item in getGoldWatchlist"
          :key="item.id"
          :item="item"
          :action="navigateToGold"
          :query="{...item}"
        />
      </div>
    </div>
    <tabs v-else @is-active="isActiveTab" class="modal-item-list" slot="body">
      <tab
        v-if="topFundWatchlist && topFundWatchlist.length"
        name="กองทุน"
        data-tab="home_following_fund"
        :selected="getActiveTab === 'fund' ? true : false"
      >
        <list-item
          v-for="(fund,index) in topFundWatchlist"
          :data-action="'open_fund'"
          :data-listname="'home_following_fund'"
          :data-fundname="fund.name"
          :key="fund.id"
          :index="index + 1"
          :name="fund.name"
          :date="fund.data_date"
          :period="'1 Day'"
          :price="fund.price"
          :change="fund.percent"
          :action="navigateToFund"
          :query="{id:fund.id}"
        ></list-item>
      </tab>
      <tab
        v-if="topStockWatchlist && topStockWatchlist.length"
        name="หุ้น"
        data-tab="home_following_stock"
        :selected="getActiveTab === 'stock' ? true : false"
      >
        <list-item
          v-for="(stock,index) in topStockWatchlist"
          :data-action="'open_stock'"
          :data-listname="'home_following_stock'"
          :data-stockname="stock.name"
          :key="stock.id"
          :index="index + 1"
          :name="stock.name"
          :date="stock.data_date"
          :period="'1 Day'"
          :price="stock.price"
          :change="stock.percent"
          :action="navigateToStock"
          :query="{name: stock.name}"
        ></list-item>
      </tab>
      <tab name="ทอง" data-tab="home_following_gold" :selected="getActiveTab === 'gold' ? true : false">
        <BoxAsset
          :data-action="'open_gold'"
          :data-listname="'home_following_gold'"
          :data-assettype="'gold'"
          :data-assetname="item.name"
          class="modal-item-list-tab"
          v-for="item in getGoldWatchlist"
          :key="item.id"
          :item="item"
          :action="navigateToGold"
          :query="{...item}"
        />
      </tab>
    </tabs>

    <div id="view-all">
      <a href="javascript:;" data-action="view_all_following" @click="viewAll()" class="view-indice">ดูทั้งหมด</a>
    </div>
  </div>
</template>

<script>
import _orderBy from 'lodash/orderBy'
import ListItem from '../../commons/ListItem'
import Tab from '../../commons/Tab'
import Tabs from '../../commons/Tabs'
import { mapGetters, mapActions } from 'vuex'
import { BoxAsset } from '../../organisms'

export default {
  components: {
    ListItem,
    Tab,
    Tabs,
    BoxAsset
  },
  data() {
    return {
      page: 20,
      defaultSize: 10,
      pageOffset: 1,
      objPeriod: {
        '1D': '1 Day',
        '1W': '1 Week',
        '1M': '1 Month',
        '3M': '3 Months',
        '6M': '6 Months',
        '1Y': '1 Year',
        '3Y': '3 Years',
        '5Y': '5 Years',
        '10Y': '10 Years'
      }
    }
  },
  watch: {
    async getIslogin() {
      if (this.getIslogin) {
        await this.findWatchlist('fund')
        await this.findWatchlist('stock')
        await this.findWatchlist('gold')
      }
    }
  },
  computed: {
    ...mapGetters('watchlist', [
      'getCountWatchlistAsset',
      'getAllWatchlist',
      'getFundWatchlist',
      'getStockWatchlist',
      'getGoldWatchlist'
    ]),
    topFundWatchlist() {
      return _orderBy(
        this.getFundWatchlist,
        item => {
          return new Number(item.percent)
        },
        ['desc']
      ).slice(0, 3)
    },
    topStockWatchlist() {
      return _orderBy(
        this.getStockWatchlist,
        item => {
          return new Number(item.percent)
        },
        ['desc']
      ).slice(0, 3)
    },
    getActiveTab() {
      return this.getCountWatchlistAsset.type[0]
    }
  },
  methods: {
    ...mapGetters('auth', ['getIslogin']),
    ...mapActions('watchlist', ['findWatchlist']),
    ...mapActions('gold', ['findGoldTraderPresent', 'findGoldSpotPreviousClose']),
    ...mapActions('stock', ['findStockQuote']),
    viewAll() {
      this.$router.replace({ name: 'miniapp-watch-list' })
    },
    navigateTo({ id, name, type }) {
      switch (type) {
        case 'fund':
          this.$router.push({ name: 'miniapp-fund-quote', query: { id: id } })
          break
        case 'stock':
          this.$router.push({
            name: 'miniapp-stock-quote',
            query: { name: name }
          })
          break
        case 'indice':
          this.$router.push({
            name: 'miniapp-indices-quote',
            query: { name: name }
          })
          break
        case 'gold':
          this.$router.push({
            name: 'miniapp-indices-gold'
          })
          break
        default:
          this.$router.push({ name: 'miniapp-market' })
          break
      }
    },
    navigateToGold({ name }) {
      switch (name) {
        case 'spot':
          this.$router.push({ name: 'miniapp-market-gold-spot' })
          break
        default:
          this.$router.push({ name: 'miniapp-market-gold-trader' })
          break
      }
    },
    navigateToFund(query) {
      this.$router.push({ name: 'miniapp-fund-quote', query: query })
    },
    async navigateToStock(query) {
      const hasInfo = await this.findStockQuote(query.name)
      hasInfo
        ? this.$router.push({
            name: 'miniapp-stock-quote',
            query: query
          })
        : null
    },
    async isActiveTab(val) {
      if (val === 'ทอง' && this.getGoldWatchlist.length) {
        await this.findGoldTraderPresent()
        await this.findGoldSpotPreviousClose('C:XAUUSD')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#following {
  .header {
    i {
      color: $color-normal-text;
    }
    display: inline-block;
    @extend %font-size-m;
    font-weight: bold;
    color: $color-normal-text;
  }
  .modal-item-list {
    margin-top: 8px;
    box-shadow: 0 0 4px 0 rgba(186, 186, 186, 0.34), 0 0 6px 0 rgba(228, 232, 234, 0);
    .modal-item-list-tab {
      padding: 8px 16px;
      border: 1px solid #efefef;
    }
  }
  .one-item-list {
    &__title {
      margin-top: 8px;
      padding: 8px 16px;
      box-shadow: 0 0 4px 0 rgba(186, 186, 186, 0.34), 0 0 6px 0 rgba(228, 232, 234, 0);
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      @extend %font-size-s;
      font-weight: bold;
    }
    &__content {
      border-bottom-right-radius: 4px;
      border-bottom-left-radius: 4px;
      padding: 16px;
      box-shadow: 0 0 4px 0 rgba(186, 186, 186, 0.24), 0 0 6px 0 rgba(228, 232, 234, 0);
      background-color: $base-white;
    }
    i {
      pointer-events: none;
    }
  }
  #view-all {
    margin-top: 16px;
    text-align: center;
    a {
      text-decoration: none;
      border-bottom: 1px solid #999999;
      @extend %font-size-ss;
      font-weight: bold;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #999999;
    }
  }
}
</style>